import { loginActions } from "../../constants/loginActionTypes";

const loginGetData = () => ({
  type: loginActions.apiAction,
});

const loginSetData = (data) => ({
  type: loginActions.apiActionSet,
  payload: data,
});

const loginSetError = (data) => ({
  type: loginActions.apiActionError,
  payload: data,
});

const logoutUser = (data) => ({
  type: loginActions.LOGOUT_USER,
  payload: data,
});

const logoutSuccess = (data) => ({
  type: loginActions.LOGOUT_USER_SUCCESS,
  payload: data,
});

const logoutFailed = (data) => ({
  type: loginActions.LOGOUT_USER_FAILED,
  payload: data,
});

const getLoginDetailsRequest = (payload) => ({
  type: loginActions.GET_LOGIN_DETAILS_REQUEST,
  payload: payload,
});

const getLoginDetailsSuccess = (payload) => ({
  type: loginActions.GET_LOGIN_DETAILS_SUCCESS,
  payload: payload,
});

const setLoginDetailsError = (payload) => ({
  type: loginActions.SET_LOGIN_DETAILS_ERROR,
  payload: payload,
});

const loginUserAction = (payload) => ({
  type: loginActions.LOGIN_ACTION,
  payload: payload,
});

const loginUserSuccess = (payload) => ({
  type: loginActions.LOGIN_ACTION_SUCCESS,
  payload: payload,
});

const getAuthToken = (payload) => ({
  type: loginActions.GET_AUTH_TOKENS,
  payload: payload,
});

const getAuthTokenSuccess = (payload) => ({
  type: loginActions.GET_AUTH_TOKEN_SUCCESS,
  payload: payload,
});

const getAuthTokenFailed = (payload) => ({
  type: loginActions.GET_AUTH_TOKEN_FAIL,
  payload: payload,
});

const setInvalidTenantUrl = (payload) => ({
  type: loginActions.SET_INVALID_TENANT_URL,
  payload: payload,
});

const localUserSignupAction = (payload) => ({
  type: loginActions.LOCAL_USER_SIGNUP,
  payload: payload,
});

const localUserLoginAction = (payload) => ({
  type: loginActions.LOCAL_USER_LOGIN,
  payload: payload,
});

const localUserForgotPasswordAction = (payload) => ({
  type: loginActions.LOCAL_USER_FORGOT_PASSWORD,
  payload: payload,
});

const localUserResetPasswordAction = (payload) => ({
  type: loginActions.LOCAL_USER_RESET_PASSWORD,
  payload: payload,
});

const verifyUserOnLoginAction = (payload) => ({
  type: loginActions.VERIFY_USER_ON_LOGIN,
  payload: payload,
});

const setLocalUserTokens = (payload) => ({
  type: loginActions.SET_LOCAL_USER_TOKEN,
  payload: payload,
});

const setLocalUserSignupSuccess = (payload) => ({
  type: loginActions.SET_LOCAL_USER_SIGNUP_SUCCESS,
  payload: payload,
});

const setLocalUserForgotPasswordSuccess = (payload) => ({
  type: loginActions.SET_LOCAL_USER_FORGOT_PASSWORD_SUCCESS,
  payload: payload,
});

const setLocalUserResetPasswordSuccess = (payload) => ({
  type: loginActions.SET_LOCAL_USER_RESET_PASSWORD_SUCCESS,
  payload: payload,
});

const setLocalUserSignupError = (payload) => ({
  type: loginActions.SET_LOCAL_USER_SIGNUP_ERROR,
  payload: payload,
});

const setLocalUserLoginError = (payload) => ({
  type: loginActions.SET_LOCAL_USER_LOGIN_ERROR,
  payload: payload,
});

const setLocalUserForgotPasswordError = (payload) => ({
  type: loginActions.SET_LOCAL_USER_FORGOT_PASSWORD_ERROR,
  payload: payload,
});

const setLocalUserResetPasswordError = (payload) => ({
  type: loginActions.SET_LOCAL_USER_RESET_PASSWORD_ERROR,
  payload: payload,
});

const setIdpToken = (payload) => ({
  type: loginActions.SET_IDP_TOKEN,
  payload: payload,
});

const getIdpToken = (payload) => ({
  type: loginActions.GET_IDP_TOKEN,
  payload: payload,
});

const verifyLocalUser = (payload) => ({
  type: loginActions.VERIFY_LOCAL_USER,
  payload: payload,
});

const veriFiedLocalUser = (payload) => ({
  type: loginActions.VERIFIED_LOCAL_USER,
  payload: payload,
});

const invalidLocalUser = (payload) => ({
  type: loginActions.INVALID_LOCAL_USER,
  payload: payload,
});

const setVerifiedWorkspaceUser = (payload) => ({
  type: loginActions.VERIFIED_WORKSPACE_LOCAL_USER,
  payload: payload,
});

const setInvalidWorkspaceUser = (payload) => ({
  type: loginActions.INVALID_WORKSPACE_LOCAL_USER,
  payload: payload,
});

const localWorkspaceLogin = (payload) => ({
  type: loginActions.WORKSPACE_LOCAL_USER_LOGIN,
  payload: payload,
});

const localWorkspaceLoginSuccess = (payload) => ({
  type: loginActions.WORKSPACE_LOCAL_USER_LOGIN_SUCCESS,
  payload: payload,
});

const localWorkspaceLoginError = (payload) => ({
  type: loginActions.WORKSPACE_LOCAL_USER_LOGIN_ERROR,
  payload: payload,
});

export {
  loginGetData,
  loginSetData,
  loginSetError,
  logoutUser,
  logoutSuccess,
  logoutFailed,
  getLoginDetailsRequest,
  getLoginDetailsSuccess,
  setLoginDetailsError,
  loginUserAction,
  loginUserSuccess,
  getAuthToken,
  getAuthTokenSuccess,
  getAuthTokenFailed,
  setInvalidTenantUrl,
  localUserLoginAction,
  localUserForgotPasswordAction,
  localUserResetPasswordAction,
  verifyUserOnLoginAction,
  setLocalUserTokens,
  setLocalUserLoginError,
  setLocalUserForgotPasswordError,
  setLocalUserResetPasswordError,
  setIdpToken,
  getIdpToken,
  verifyLocalUser,
  invalidLocalUser,
  veriFiedLocalUser,
  setVerifiedWorkspaceUser,
  setInvalidWorkspaceUser,
  localWorkspaceLogin,
  localWorkspaceLoginSuccess,
  localWorkspaceLoginError,
  localUserSignupAction,
  setLocalUserSignupSuccess,
  setLocalUserForgotPasswordSuccess,
  setLocalUserResetPasswordSuccess,
  setLocalUserSignupError,
};
